import React, { FC, MouseEvent, useState } from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../../utils/styles';
import t from '../../../labels/labelling-utils';

import './list.scss';

export type ListTags = 'ul' | 'ol';
export const tagList: ListTags[] = ['ul', 'ol'];

export interface IList extends IComponent {
  activeItemIndex?: number;
  emptyListMessage?: string;
  listItems: string[];
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  tag?: ListTags;
}

const classNames = (): IClassNames =>
  makeClassNames({
    list: 'list-items',
    listItemActive: 'list-items--active',
    emptyListMessage: 'no-list-items',
  });

export const cn = classNames();

const List: FC<IList> = ({
  activeItemIndex = -1,
  emptyListMessage = t('search-input.no.matches.found'),
  listItems,
  onClick = () => {},
  tag = 'ul',
}) => {
  const [isLoading /* , setIsLoading */] = useState<boolean>(false);

  const Tag = tag as keyof JSX.IntrinsicElements;

  const isListItemActive = (itemIndex: number) => {
    return itemIndex === activeItemIndex ? cn.listItemActive : '';
  };

  return isLoading ? (
    <React.Fragment>{t('search-input.loading')}</React.Fragment>
  ) : (
    <Tag className={cn.list}>
      {listItems?.length === 0 && <li>{emptyListMessage}</li>}
      {listItems.map((listItem, index) => {
        return (
          <li className={isListItemActive(index)} key={index} data-index={index} onClick={onClick}>
            {listItem}
          </li>
        );
      })}
    </Tag>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  List.propTypes = {
    activeItemIndex: PropTypes.number,
    emptyListMessage: PropTypes.string,
    listItems: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    onClick: PropTypes.func,
    tag: PropTypes.oneOf(tagList),
  };
}

export default List;
